module.exports = __webpack_public_path__ + "img/FresnoC2C-Logo-Horizontal.061085d3.png";